import type { PortfolioCollectionPlatform } from "@repo/shared/types";
import { Badge } from "@/components/ui/badge";
import { useLocalize } from "@/lib/i18n/use-localize";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./platform-badges.i18n";
import { platformLabel } from "./platform-label";

type PlatformBadgesProps = {
  /** Platform row ids the portfolio is assigned to. */
  platformIds: string[];
  /** The collection's platforms, for the labels. */
  platforms: Pick<PortfolioCollectionPlatform, "id" | "labelI18n">[];
};

/** The platforms a portfolio is assigned to, as badges ("None" when untagged). */
export function PlatformBadges({ platformIds, platforms }: PlatformBadgesProps) {
  const localize = useLocalize();
  const t = useT(T);

  if (platformIds.length === 0) {
    return <span className="text-xs text-muted-foreground italic">{t.noPlatforms}</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {platformIds.map((platformId) => (
        <Badge key={platformId} variant="outline" className="text-xs">
          {platformLabel(platforms, platformId, localize)}
        </Badge>
      ))}
    </div>
  );
}
